module.exports = __webpack_public_path__ + "static/media/udemy-logo.442622c1.png";